import {
  AuctionResponse,
  getAuctionProgressStatus,
} from '@bonhams1793/bonhams-typescript'
import React, { HTMLAttributes, RefObject } from 'react'

import { EyeOpenIcon } from '@nx/fire/assets'
import { FireButton } from '@nx/fire/button'
import { getAuctionStatusLabels } from '@nx/helpers'
import { getTranslate } from '@nx/translations'
import { useDataLayer } from '@nx/utils/google-tag-manager'

import translate from './AuctionViewingsButton.translate.json'

const { text } = getTranslate(translate)
const AUCTION_STATUS_LABELS = getAuctionStatusLabels('status')

export const AuctionViewingsButton = ({
  auctionViewingsRef,
  auction,
  ...buttonProps
}: {
  auctionViewingsRef?: RefObject<HTMLButtonElement>
  auction: AuctionResponse
} & HTMLAttributes<HTMLButtonElement>) => {
  const dataLayer = useDataLayer()
  const auctionProgressStatus = getAuctionProgressStatus({
    status: auction.sSaleStatus,
    type: auction.sSaleType,
    biddingStatus: auction.sBidOnlineStatus,
    endDate: auction.dates.end.datetime,
    startDate: auction.dates.start[0].date.datetime,
    localTimezone: auction.dates.start[0].date.timezone.iana,
    consignmentEndDate: auction.dates.consignment?.datetime || null,
    isCharity: Boolean(auction.lCharity),
  })

  const handleOnClick: React.MouseEventHandler<HTMLButtonElement> = () => {
    const auctionViewingsButton = auctionViewingsRef?.current

    /* istanbul ignore next */
    if (!auctionViewingsButton) return

    const auctionViewingRect = auctionViewingsButton.getBoundingClientRect()

    window.scrollTo({
      top: auctionViewingRect.top,
      behavior: 'instant',
    })

    auctionViewingsButton.focus()

    if (auctionViewingsButton.ariaExpanded === 'false') {
      auctionViewingsButton.click()
    }

    dataLayer.push({
      event: 'auctionViewing',
      auctionDetail: {
        id: auction.iSaleNo,
        name: auction.sSaleName,
        location: auction.sVenue,
        status: AUCTION_STATUS_LABELS[auctionProgressStatus],
        department: auction.departments
          .map((department) => department.sDepartment)
          .join(','),
      },
    })
  }

  return (
    <FireButton
      variant="ghost"
      startIcon={EyeOpenIcon}
      onClick={handleOnClick}
      {...buttonProps}
    >
      {text('title')}
    </FireButton>
  )
}
